import { BRAND, isMarketGB } from 'src/constants/main';
import { NotReadyToBuyOnlineStyled } from './NotReadyToBuyOnlineStyled';
import { SC } from 'src/styles/theme';
import React from 'react';
import { NotReadyToBuyOnlineStyledAC } from './AC/NotReadyToBuyOnlineStyledAC';
import { NotReadyToBuyOnlineStyledAP } from './AP/NotReadyToBuyOnlineStyledAP';
import { NotReadyToBuyOnlineStyledDS } from './DS/NotReadyToBuyOnlineStyledDS';
import { NotReadyToBuyOnlineStyledOV } from './OV/NotReadyToBuyOnlineStyledOV';
import { NotReadyToBuyOnlineStyledOVGB } from './OV/NotReadyToBuyOnlineStyledOVGB';

export interface NotReadyToBuyOnlineProps extends SC {}

export const NotReadyToBuyOnline = (props: NotReadyToBuyOnlineProps) => {
    if (BRAND === 'AC') return <NotReadyToBuyOnlineStyledAC {...props} />;
    if (BRAND === 'AP') return <NotReadyToBuyOnlineStyledAP {...props} />;
    if (BRAND === 'DS') return <NotReadyToBuyOnlineStyledDS {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? <NotReadyToBuyOnlineStyledOVGB {...props} /> : <NotReadyToBuyOnlineStyledOV {...props} />;
    return <NotReadyToBuyOnlineStyled {...props} />;
};

export default NotReadyToBuyOnline;
